import React, { useState, useEffect, useRef } from "react";
import { TailSpin } from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";

import { sendMail } from "../lib/api-lib";

function CmsForm({ component, page_id = "" }) {
  const [showModal, setShowModal] = useState(true);
  const [showLoading, setShowLoading] = useState(false);
  const [showResult, setShowResult] = useState(0);
  const [bottomReached, setbottomReached] = useState(false);
  const [privacyWarning, setPrivacyWarning] = useState(false);

  const form_data = {
    name: "",
    email: "",
    phone: "",
    message: "",
  };

  const handleSubmit = async (event) => {
    // console.log(event);
    event.preventDefault();

    const data = {
      name: event.target.name.value,
      email: event.target.email.value,
      phone: event.target.phone.value,
      subject: "Message from website",
      message: event.target.message.value,
    };

    setShowLoading(true);

    // const response = await sendMail(data);

    fetch(process.env.BASE_URL + "/api/sendmail", {
      body: JSON.stringify(data),
      method: "POST",
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setShowLoading(false);
        if (data.response == 1) {
          setShowResult(1);
        } else {
          setShowResult(2);
        }
      })
      .catch((error) => {
        setShowLoading(false);
        setShowResult(2);
      });
  };

  const closeForm = () => {
    document.querySelector("body, html").classList.remove("no-scroll");
    setShowModal(false);
    setShowResult(0);
  };

  const listInnerRef = useRef();

  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollTop + clientHeight === scrollHeight) {
        setbottomReached(true);
        // console.log("reached bottom");
      }
    }
  };

  return (
    <>
      {showModal ? (
        <>
          <div className="contact-form">
            <div className="contact-form-container relative">
              {showResult == 0 ? (
                <>
                  {showLoading ? (
                    <div className="sendLoader">
                      <TailSpin
                        type="Puff"
                        color="#FFFFFF"
                        height={70}
                        width={70}
                        timeout={3000}
                      />
                      <div>sending...</div>
                    </div>
                  ) : (
                    ""
                  )}
                  {/*content*/}
                  <form className="w-full" onSubmit={handleSubmit}>
                    <div className="form-contact">
                      {/*body*/}
                      <div className="relative p-6 flex-auto">
                        <div className="form-row py-4">
                          <label className="" htmlFor="form_name">
                            Nome e cognome <span className="required">*</span>
                          </label>
                          <input
                            id="form_name"
                            className=""
                            type="text"
                            placeholder=""
                            aria-label="Full name (required)"
                            name="name"
                            defaultValue={form_data.name}
                            required
                          />
                        </div>
                        <div className="form-row grid md:grid-cols-2 gap-4">
                          <div className="form-fld py-4">
                            <label
                              className="theme-c2 "
                              htmlFor="form_email"
                            >
                              Email <span className="required">*</span>
                            </label>
                            <input
                              id="form_email"
                              className=""
                              type="text"
                              placeholder=""
                              aria-label="Email (obbligatorio)"
                              name="email"
                              defaultValue={form_data.email}
                              required
                            />
                          </div>

                          <div className="form-fld py-4">
                            <label className="" htmlFor="form_name">
                              Telefono
                            </label>
                            <input
                              id="form_phone"
                              className=""
                              type="text"
                              placeholder=""
                              aria-label="Phone"
                              defaultValue={form_data.phone}
                              name="phone"
                            />
                          </div>
                        </div>
                        <div className="form-row py-4">
                          <label
                            className="theme-c2 "
                            htmlFor="form_message"
                          >
                            Messaggio
                          </label>
                          <textarea
                            id="form_message"
                            className=""
                            type="text"
                            placeholder=""
                            aria-label="Messaggio"
                            name="message"
                            defaultValue={form_data.message}
                          ></textarea>
                        </div>
                      </div>
                      {/*footer*/}

                      <div className="flex items-center justify-center pb-6 relative">
                        <input
                          type="checkbox"
                          value="1"
                          id="form_terms"
                          name="terms"
                          className="mr-4 cursor-pointer"
                          required
                        />

                        <label
                          className=""
                          htmlFor="form_terms"
                        >
                          accetto la <a href="/privacy" target="_blank">
                          Privacy Policy
                          </a> (regolamento europeo n. 2016/679)
                        </label>
                      </div>
                      <div className="flex items-center justify-center p-6">
                        <button className="externalBtn" type="submit">
                          INVIA MESSAGGIO
                        </button>
                      </div>
                    </div>
                  </form>
                </>
              ) : (
                <>
                  <div className="form-cms-container-inner">
                    <div className="relative p-6 flex-auto">
                      <div className="z-10 flex flex-col justify-center items-center">
                        {showResult == 1 ? (
                          <>
                            <h5 className="text-center">
                              Grazie per averci contattato!
                            </h5>
                            <p className="font-normal text-center">
                              Ti risponderemo il prima possibile
                            </p>
                            {/* <div className="mt-8 mb-12">
                              <button
                                className="sendBtn"
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  closeForm();
                                }}
                              >
                                Chiudi
                              </button>
                            </div> */}
                          </>
                        ) : (
                          <>
                            <h5 className="text-error text-center">
                              Si è verificato un errore!
                            </h5>
                            <p className="font-normal mt-8 text-center">
                              Ci scusiamo per il disguido.
                              <br />
                              Ti invitiamo a contattarci scrivendo a{" "}
                              <a
                                href="mailto:info@webeable.it"
                                className=""
                              >
                                info@webeable.it
                              </a>
                            </p>
                            <div className="flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b">
                              <button
                                className="externalBtn"
                                type="button"
                                onClick={() => {
                                  setShowResult(0);
                                }}
                              >
                                RIPROVA
                              </button>
                            </div>
                            {/* <div className="mt-8 mb-12">
                              <button
                                className="sendBtn"
                                type="button"
                                onClick={(e) => {
                                  e.preventDefault();
                                  closeForm();
                                }}
                              >
                                Chiudi
                              </button>
                            </div> */}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </>
      ) : null}
    </>
  );
}

export default CmsForm;
